










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Layout extends Vue {
  @Prop(String) readonly classPrefix: string | undefined;

  created() {
    const layoutWrapper: Element | null = document.querySelector(
      ".layoutWrapper"
    );
    if (layoutWrapper) {
      layoutWrapper.setAttribute(
        "style",
        `--vh:${window.innerHeight * 0.01}px`
      );
    }
  }
}
